import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const OnePage = React.lazy(() => import("../pages/Landing/OnePage"));
const SalonsLocation = React.lazy(
  () => import("../pages/Landing/OnePage/salons-locations/SalonsLocation"),
);

const VendorLogin = React.lazy(
  () => import("../pages/vendor-login/VendorLogin"),
);
const VendorRegister = React.lazy(
  () => import("../pages/vendor-register/VendorRegister"),
);
const AdminLogin = React.lazy(() => import("../pages/admin-login/AdminLogin"));
const Logout = React.lazy(() => import("../pages/Authentication/Logout"));
const Register = React.lazy(() => import("../pages/Authentication/Register"));
const ForgetPasswordPage = React.lazy(
  () => import("../pages/Authentication/ForgetPassword"),
);
const UserProfile = React.lazy(
  () => import("../pages/Authentication/user-profile"),
);
const DashboardEcommerce = React.lazy(
  () => import("../pages/DashboardEcommerce"),
);

const Branches = React.lazy(
  () => import("../pages/vendor-dashboard/branches/Branches"),
);
const Bookings = React.lazy(
  () => import("../pages/vendor-dashboard/bookings/Bookings"),
);
const Services = React.lazy(
  () => import("../pages/vendor-dashboard/services/Services"),
);
const CalendarBookings = React.lazy(
  () => import("../pages/vendor-dashboard/calendar-bookings/CalendarBookings"),
);
const Tax = React.lazy(() => import("../pages/vendor-dashboard/tax/Tax"));
const StaffEarnings = React.lazy(
  () => import("../pages/vendor-dashboard/staff-earnings/StaffEarnings"),
);
const Promotions = React.lazy(
  () => import("../pages/vendor-dashboard/promotions/Promoions"),
);
const Staffs = React.lazy(
  () => import("../pages/vendor-dashboard/staffs/Staffs"),
);
const Products = React.lazy(
  () => import("../pages/vendor-dashboard/products/Products"),
);
const Customers = React.lazy(
  () => import("../pages/vendor-dashboard/customers/Customers"),
);
const Reviews = React.lazy(
  () => import("../pages/vendor-dashboard/reviews/Reviews"),
);
const Settings = React.lazy(
  () => import("../pages/vendor-dashboard/settings/Settings"),
);
const Categories = React.lazy(
  () => import("../pages/vendor-dashboard/categories/Categories"),
);
const SubCategories = React.lazy(
  () => import("../pages/vendor-dashboard/sub-categories/SubCategories"),
);

const AdminDashboard = React.lazy(
  () => import("../pages/admin-dashboard/dashboard/Dashboard"),
);
const Vendors = React.lazy(
  () => import("../pages/admin-dashboard/vendors/Vendors"),
);
const AllSubscriptions = React.lazy(
  () => import("../pages/admin-dashboard/subscriptions/AllSubscriptions"),
);
const ActiveSubscription = React.lazy(
  () =>
    import("../pages/admin-dashboard/subscriptions/active-subscription/ActiveSubscription"),
);
const PendingSubscription = React.lazy(
  () =>
    import("../pages/admin-dashboard/subscriptions/pending-subscription/PendingSubscription"),
);
const ExpiredSubscription = React.lazy(
  () =>
    import("../pages/admin-dashboard/subscriptions/expired-subscription/ExpiredSubscription"),
);

const Plans = React.lazy(() => import("../pages/admin-dashboard/plans/Plans"));
const Payments = React.lazy(
  () => import("../pages/admin-dashboard/payments/Payments"),
);
const Blog = React.lazy(() => import("../pages/admin-dashboard/blog/Blog"));
const Notifications = React.lazy(
  () => import("../pages/admin-dashboard/notifications/Notifications"),
);
const LandingPageSettings = React.lazy(
  () =>
    import("../pages/admin-dashboard/landing-page-settings/LandingPageSettings"),
);
const Pages = React.lazy(() => import("../pages/admin-dashboard/pages/Pages"));
const AdminPromotions = React.lazy(
  () => import("../pages/admin-dashboard/promotions/Promotions"),
);
const AdminTax = React.lazy(() => import("../pages/admin-dashboard/tax/Tax"));

const DashboardLayout = React.lazy(
  () => import("../pages/vendor-dashboard/DashboardLayout"),
);
const AdminLayout = React.lazy(
  () => import("../pages/admin-dashboard/AdminboardLayout"),
);
const IframeForm = React.lazy(() => import("../pages/iframe-form/IframeForm"));
const IframeTest = React.lazy(() => import("../pages/iframe-form/IframeTest"));
const SalonProfile = React.lazy(
  () => import("../pages/salon-profile/SalonProfile"),
);
const Booking = React.lazy(
  () => import("../pages/appointment/AppointmentPage"),
);
const Admins = React.lazy(
  () => import("../pages/admin-dashboard/admins/Admin"),
);
const ForgotPassword = React.lazy(
  () => import("../pages/forgot-password/ForgotPassword"),
);
const ResetPassword = React.lazy(
  () => import("../pages/reset-password/ResetPassword"),
);
const AdminSettings = React.lazy(
  () => import("../pages/admin-dashboard/settings/Settings"),
);
const WhyUs = React.lazy(() => import("../pages/Landing/OnePage/why-us/WhyUs"));
const CaseStudies = React.lazy(
  () => import("../pages/Landing/OnePage/case-studies/CaseStudies"),
);
const Pricing = React.lazy(
  () => import("../pages/Landing/OnePage/pricing/Pricing"),
);
const AboutUs = React.lazy(
  () => import("../pages/Landing/OnePage/abouts-us/AboutUS"),
);
const WebsiteBlogs = React.lazy(
  () => import("../pages/Landing/OnePage/website-blogs/Blogs"),
);
const SoftwarePage = React.lazy(
  () => import("../pages/Landing/OnePage/software/Software"),
);
const bookingWidget = React.lazy(
  () => import("../pages/vendor-dashboard/booking-widget/BookingWidget"),
);
const PaymentCheck = React.lazy(
  () => import("../pages/payment-check/PaymentCheck"),
);
const Menus = React.lazy(() => import("../pages/admin-dashboard/menus/Menus"));
const MenuItem = React.lazy(
  () => import("../pages/admin-dashboard/menus/MenuItemsPage"),
);
const NoPermission = React.lazy(
  () => import("../pages/no-permission/NoPermission"),
);

const DynamicPage = React.lazy(
  () => import("../pages/Landing/OnePage/dynamic-page/DynamicPage"),
);
const SalonSubscription = React.lazy(
  () =>
    import("../pages/vendor-dashboard/salon-subscription/SalonSubscription"),
);
const SubscriptionOver = React.lazy(
  () => import("../pages/subscription-over/SubscriptionOver"),
);
const SubscriptionPlans = React.lazy(
  () => import("../pages/subscription-plans/SubscriptionPlans"),
);

const PlansForSalon = React.lazy(() => import("../pages/plans/PlansForSalon"));
const BookingReview = React.lazy(
  () => import("../pages/customer-review/CustomerReview"),
);
const VerifyEmail = React.lazy(() => import("../pages/verify/VerifyEmail"));
const AdminFaqs = React.lazy(
  () => import("../pages/admin-dashboard/faqs/Faqs"),
);

const EmployeeWorkSessions = React.lazy(
  () => import("../pages/vendor-dashboard/employee-work-sessions/WorkSessions"),
);
const OwnerPayroll = React.lazy(
  () => import("../pages/vendor-dashboard/owner-payroll/OwnerPayroll"),
);
const SalonCart = React.lazy(
  () => import("../pages/vendor-dashboard/cart/Register"),
);
const CustomerLayout = React.lazy(
  () => import("../pages/customer-account/CustomerLayout"),
);
const MyAccount = React.lazy(
  () => import("../pages/customer-account/MyAccount"),
);
const EditProfile = React.lazy(
  () => import("../pages/vendor-dashboard/profile/EditProfile"),
);
const canAccessCalendar = (subscriptionData) => {
  if (!subscriptionData) return false;

  const isTrial = subscriptionData?.status === "trial";

  if (isTrial) {
    console.log("Subscription is trial - calendar access granted");
    return true;
  }

  const plan = subscriptionData?.subscription?.plan || {};
  const hasPermission = plan.includes_calendar_management === true;

  console.log("Calendar Check:", {
    isTrial: false,
    planPermission: hasPermission,
    subscriptionStatus: subscriptionData?.subscription?.status,
    plan,
  });

  return hasPermission;
};

const canAccessCustomers = (subscriptionData) => {
  if (!subscriptionData) return false;

  const isTrial = subscriptionData?.status === "trial";

  if (isTrial) {
    console.log("Subscription is trial - customers access granted");
    return true;
  }

  const plan = subscriptionData?.subscription?.plan || {};
  const hasPermission = plan.includes_customer_management === true;

  console.log("Customers Check:", {
    isTrial: false,
    planPermission: hasPermission,
    subscriptionStatus: subscriptionData?.status,
    plan,
  });

  return hasPermission;
};

const canAccessSalonPages = (subscriptionData) => {
  if (!subscriptionData) return false;

  const allowedStatuses = ["active", "trial"];

  return allowedStatuses.includes(subscriptionData.status);
};

const withSuspense = (Component) => (
  <Suspense
    fallback={
      <div className="t-fixed t-inset-0 t-z-[9999] t-flex t-items-center t-justify-center t-bg-white/90 dark:t-bg-black/80 t-backdrop-blur-sm">
        <div className="t-flex t-flex-col t-items-center t-space-y-6">
          <div className="t-relative">
            <div className="t-w-20 t-h-20 t-rounded-full t-border-8 t-border-gray-200 dark:t-border-gray-800"></div>
            <div className="t-absolute t-top-0 t-left-0 t-w-20 t-h-20 t-rounded-full t-border-8 t-border-transparent t-border-t-secondary t-border-l-secondary t-animate-spin"></div>
            <div className="t-absolute t-top-0 t-left-0 t-w-20 t-h-20 t-rounded-full t-border-8 t-border-transparent t-border-b-secondary t-border-r-secondary t-animate-spin t-[animation-direction:reverse] t-[animation-duration:3s]"></div>
          </div>

          <div className="t-flex t-space-x-2">
            {[0, 0.2, 0.4].map((delay) => (
              <div
                key={delay}
                className="t-w-4 t-h-4 t-bg-gradient1 t-rounded-full t-animate-bounce"
                style={{ animationDelay: `${delay}s` }}
              />
            ))}
          </div>

          <p className="t-text-lg t-font-medium t-text-gray-700 dark:t-text-gray-300 t-animate-pulse">
            Loading...
          </p>
        </div>
      </div>
    }
  >
    <Component />
  </Suspense>
);
const authProtectedRoutes = [
  {
    path: "/account",
    allowedRoles: ["customer"],
    element: withSuspense(CustomerLayout),
    children: [{ index: true, component: withSuspense(MyAccount) }],
  },
  {
    path: "/salon",

    allowedRoles: ["salon_owner", "employee"],
    element: withSuspense(DashboardLayout),
    children: [
      {
        index: true,
        component: () => {
          const { user } = useSelector((state) => state.user);

          if (!user) return <Navigate to="/login" replace />;

          if (user.role === "salon_owner")
            return withSuspense(DashboardEcommerce);
          if (user.role === "employee") return withSuspense(CalendarBookings);

          return <Navigate to="/no-permission" replace />;
        },
      },
      { path: "dashboard", component: withSuspense(DashboardEcommerce) },
      { path: "branches", component: withSuspense(Branches) },
      { path: "bookings", component: withSuspense(Bookings) },
      { path: "services", component: withSuspense(Services) },
      { path: "products", component: withSuspense(Products) },
      {
        path: "calendar-bookings",
        component: withSuspense(CalendarBookings),
        requiredPermissions: canAccessCalendar,
      },
      { path: "tax", component: withSuspense(Tax) },
      { path: "staff-earnings", component: withSuspense(StaffEarnings) },
      { path: "promotions", component: withSuspense(Promotions) },
      { path: "settings", component: withSuspense(Settings) },
      { path: "staffs", component: withSuspense(Staffs) },
      { path: "subscription", component: withSuspense(SubscriptionPlans) },
      { path: "plans", component: withSuspense(PlansForSalon) },
      { path: "work-sessions", component: withSuspense(EmployeeWorkSessions) },
      {
        path: "/salon/subscription/success",
        component: withSuspense(SalonSubscription),
      },

      {
        path: "customers",
        component: withSuspense(Customers),
        requiredPermissions: canAccessCustomers,
      },
      { path: "employees-payroll", component: withSuspense(OwnerPayroll) },
      { path: "reviews", component: withSuspense(Reviews) },
      { path: "booking-widget", component: withSuspense(bookingWidget) },
      { path: "cart", component: withSuspense(SalonCart) },
      { path: "profile", component: withSuspense(EditProfile) },
      { path: "*", component: <Navigate to="/salon" /> },
    ],
  },
  {
    path: "/admin",
    allowedRoles: ["admin"],
    element: withSuspense(AdminLayout),
    children: [
      { index: true, component: withSuspense(AdminDashboard) },
      { path: "dashboard", component: withSuspense(AdminDashboard) },
      { path: "salons", component: withSuspense(Vendors) },
      { path: "subscriptions", component: withSuspense(AllSubscriptions) },
      { path: "faqs", component: withSuspense(AdminFaqs) },
      {
        path: "active-subscription",
        component: withSuspense(ActiveSubscription),
      },
      {
        path: "pending-subscription",
        component: withSuspense(PendingSubscription),
      },
      {
        path: "expired-subscription",
        component: withSuspense(ExpiredSubscription),
      },
      { path: "plans", component: withSuspense(Plans) },
      { path: "payments", component: withSuspense(Payments) },
      { path: "promotions", component: withSuspense(AdminPromotions) },
      { path: "pages", component: withSuspense(Pages) },
      { path: "tax", component: withSuspense(AdminTax) },
      { path: "blog", component: withSuspense(Blog) },
      { path: "notifications", component: withSuspense(Notifications) },
      { path: "settings", component: withSuspense(AdminSettings) },
      { path: "admins", component: withSuspense(Admins) },
      { path: "categories", component: withSuspense(Categories) },

      { path: "sub-categories", component: withSuspense(SubCategories) },
      { path: "menus/:menuId", component: withSuspense(MenuItem) },
      { path: "menus", component: withSuspense(Menus) },
      {
        path: "landing-page-settings",
        component: withSuspense(LandingPageSettings),
      },
      { path: "profile", component: withSuspense(EditProfile) },
    ],
  },
];

const publicRoutes = [
  { path: "/", element: withSuspense(OnePage) },
  { path: "/why-apointli", element: withSuspense(WhyUs) },
  { path: "/case-studies", element: withSuspense(CaseStudies) },
  { path: "/pricing", element: withSuspense(Pricing) },
  { path: "/about-us", element: withSuspense(AboutUs) },
  { path: "/software", element: withSuspense(SoftwarePage) },
  { path: "/blogs", element: withSuspense(WebsiteBlogs) },
  { path: "/page/:slug", element: withSuspense(DynamicPage) },
  { path: "/booking/payment-check/:id", element: withSuspense(PaymentCheck) },

  { path: "/salons-location", element: withSuspense(SalonsLocation) },
  { path: "/logout", element: withSuspense(Logout) },
  { path: "/login", element: withSuspense(VendorLogin) },
  { path: "/register", element: withSuspense(VendorRegister) },
  { path: "/forgot-password", element: withSuspense(ForgotPassword) },
  { path: "/reset-password", element: withSuspense(ResetPassword) },
  { path: "/verify-email", element: withSuspense(VerifyEmail) },
  { path: "no-permission", element: withSuspense(NoPermission) },
  { path: "booking-review/:id", element: withSuspense(BookingReview) },
  { path: "subscription-over", element: withSuspense(SubscriptionOver) },
  { path: "/admin/login", element: withSuspense(AdminLogin) },
  { path: "booking-iframe/:salonID", element: withSuspense(IframeForm) },
  { path: "/salon-profile/:salonID", element: withSuspense(SalonProfile) },
  { path: "/booking/:salonID", element: withSuspense(Booking) },
  { path: "test-iframe", element: withSuspense(IframeTest) },
];

export { authProtectedRoutes, publicRoutes };
